import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "./components/ui/sonner";
import { queryClient } from "./lib/queryClient";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

// Layouts
import MarketingLayout from "./layouts/MarketingLayout";

// Marketing Pages
import LandingPage from "./pages/LandingPage";
import FundMatchPage from "./pages/products/FundMatchPage";
import AdminHubPage from "./pages/products/AdminHubPage";
import ImpactGrowPage from "./pages/products/ImpactGrowPage";
import ResourceHubPage from "./pages/products/ResourceHubPage";
import DataIntelPage from "./pages/products/DataIntelPage";

// Auth
import LoginPage from "./pages/LoginPage";

// Dashboard
import Dashboard from "./pages/Dashboard";
import DashboardV1 from "./pages/DashboardV1";

// Onboarding
import OnboardingFlow from "./pages/onboarding/OnboardingFlow";
import ChatOnboarding from "./pages/ChatOnboarding";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <div className="App">
          <Toaster position="top-right" />
          <BrowserRouter>
            <Routes>
              {/* Marketing Routes */}
              <Route path="/" element={<MarketingLayout><LandingPage /></MarketingLayout>} />
              <Route path="/products/fundmatch"  element={<MarketingLayout><FundMatchPage /></MarketingLayout>} />
              <Route path="/products/adminhub"   element={<MarketingLayout><AdminHubPage /></MarketingLayout>} />
              <Route path="/products/impactgrow" element={<MarketingLayout><ImpactGrowPage /></MarketingLayout>} />
              <Route path="/products/resourcehub" element={<MarketingLayout><ResourceHubPage /></MarketingLayout>} />
              <Route path="/products/dataintel"  element={<MarketingLayout><DataIntelPage /></MarketingLayout>} />

              {/* Auth */}
              <Route path="/login" element={<LoginPage />} />

              {/* Protected Dashboard */}
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              {/* v1 Classic View — old campaign system for comparison/rollback */}
              <Route path="/dashboardv1" element={<ProtectedRoute><DashboardV1 /></ProtectedRoute>} />

              {/* Onboarding (public — creates account) */}
              <Route path="/onboarding" element={<OnboardingFlow />} />
              <Route path="/onboarding/chat" element={<ChatOnboarding />} />

              {/* Catch-all */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
